import { Link } from "react-router-dom";

/**
 * E-E-A-T author block rendered at the end of every blog article, after the
 * closing CTA. Same marble & thin-gold treatment as BlogCTA but flatter and
 * without a primary button so it doesn't compete with the CTA above it.
 */
export default function BlogAuthor({ testid = "blog-author" }) {
  return (
    <section
      className="mt-8 mb-4 rounded-lg border px-6 py-6"
      style={{
        background: "rgba(22,24,33,0.55)",
        borderColor: "rgba(201, 167, 85, 0.25)",
      }}
      data-testid={testid}
    >
      <h3
        className="font-serif text-[18px] leading-[1.2]"
        style={{
          color: "var(--gold)",
          fontFamily: "'Playfair Display', Georgia, serif",
          margin: 0,
          letterSpacing: "-0.005em",
        }}
        data-testid={`${testid}-title`}
      >
        About the author
      </h3>
      <p
        className="mt-3 text-[14px] leading-relaxed"
        style={{ color: "var(--text)" }}
        data-testid={`${testid}-bio`}
      >
        Jonathan Mendola built{" "}
        <Link to="/" style={{ color: "var(--gold)" }}>
          The Philosopher Test
        </Link>{" "}
        — a six-trait model calibrated on 10,000 simulated respondents,
        matching people with eight philosophers. He is not an academic
        philosopher; he is a builder who got obsessed with the question of how
        differently people can be serious about the same life.
      </p>
      <p
        className="mt-3 text-[13px]"
        style={{ color: "var(--muted)" }}
        data-testid={`${testid}-links`}
      >
        <a
          href="mailto:contact@thephilosophertest.com"
          style={{ color: "var(--muted)", textDecoration: "underline" }}
          data-testid={`${testid}-email`}
        >
          contact@thephilosophertest.com
        </a>
        {" · "}
        <Link
          to="/blog"
          style={{ color: "var(--muted)", textDecoration: "underline" }}
          data-testid={`${testid}-more`}
        >
          More essays on the blog
        </Link>
      </p>
    </section>
  );
}
